<template>
    <div class="field is-expanded">
        <model-select :options="options"
                      v-model="invoice_details_id"
                      class="input"
                      placeholder="Select Contact Details">
        </model-select>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
  components: {
          ModelSelect
  },
  computed: {
      invoice_details_id: {
          get() {
              return this.$store.getters.getCustomInvoice.invoice_details_id
          },
          set(value) {
              this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'invoice_details_id', value: value })
          }
      },
      options() {
          return this.$store.getters.getCustomInvoiceContactDetails
      }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceDetailsSelect.vue